import HTTP from '../common/http-common';

const END_POINT = '/insurance';

const listInsurance = () => HTTP.get(END_POINT);
const listInsuranceByInsId = (insId) => HTTP.get(END_POINT+ "/" + insId);
const isExistInsuranceCode = (insCode, insId) => HTTP.get(END_POINT +  "/exist/" + insCode + "/" + insId);
const insertInsurance = (data) => HTTP.post(END_POINT, {
    insCode: data.insCode,
    insName: data.insName,
    insNickName: data.insNickName,
    discountList : data.discountList
});
const updateInsurance = (data) => HTTP.post(END_POINT + "/" + data.insId, {
    insCode: data.insCode,
    insName: data.insName,
    insNickName: data.insNickName,
    discountList : data.discountList
});
const deleteInsurance = (insId) => HTTP.delete(END_POINT + "/" + insId);

export {
    listInsurance,
    listInsuranceByInsId,
    isExistInsuranceCode,
    insertInsurance,
    updateInsurance,
    deleteInsurance
}